import api from './Api'

const route = '/chat'

export default {
  send: payload => api().post(`${route}/send`, payload),
  listConversations: params => api().get(`${route}/list-conversations`, { params }),
  exportToExcel: params => api().get(`${route}/export-conversations`, {
    params,
    responseType: 'blob' // Importante para manejar archivos binarios
  })
}
